module.exports = __webpack_public_path__ + "img/SurgicallyAssistedFractureRepair.d30f89d1.jpg";